import React, { useState } from 'react';
import Avatar from '../common/Avatar';
import createMarkup from '../../helpers/createMarkup';
import { Fragment } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Media } from 'reactstrap';
import { useSelector } from 'react-redux';

const Comment = ({ id, dropComment, author: { firstname, lastname, image }, commnet }) => {
    
    const { role } = useSelector(state => state.auth.user);
    const [isOpen, setIsOpen] = useState(false);

    return  <Fragment key={id}>
                <Media className="mt-3" id={id}>
                    <Avatar src={image?`${import.meta.env.VITE_URL}/storage/${image}`:undefined}/>
                    <Media body className="ml-2 fs--1" style={{ maxWidth: commnet.length>=48?'80%':'auto' }}>
                        <p className="mb-1 bg-200 rounded-soft p-2">
                            <span className="font-weight-semi-bold text-primary">
                                {firstname} {lastname}
                            </span>
                            <span className="ml-1" dangerouslySetInnerHTML={createMarkup(commnet)} />
                        </p>
                    </Media>
                    {role==='manager'&&
                        <Dropdown isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
                            <DropdownToggle caret className="btn-falcon-default btn-sm border-0 shadow-none bg-transparent" />
                            <DropdownMenu right>
                                <DropdownItem className="text-danger" onClick={()=>dropComment(id)} >Eliminar</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    }
                </Media>
            </Fragment>
}

export default Comment;